import workspaceQuery from 'graphql/queries/sales/DeliveryMethodsWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/sales/DeliveryMethodsListQuery.graphql';
import instanceQuery from 'graphql/queries/sales/DeliveryMethodsQuery.graphql';
import defaultQuery from 'graphql/queries/sales/DeliveryMethodsDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/DeliveryMethodsMutation.graphql';
import fragment from 'graphql/fragments/sales/DeliveryMethodsFragment.graphql';

const DeliveryMethod = {
  type: 'DeliveryMethod',
  title: 'Delivery Methods',
  formTitle: 'Delivery Method',
  formUrl: '/Sales/Delivery/Details/',
  workspaceUrl: '/Sales/Delivery/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SALES_DELIVERY_METHODS',
};

export default DeliveryMethod;
